import type * as lazyIndex from './lazyIndex';
import {
    LazyImport,
    LazyModule,
    registerLazyOrchestrator,
    createLazyComponent,
} from 'owa-bundling';
import { showActionRestrictionDueToPolicy } from './actions/showActionRestrictionDueToPolicy';
import { showUpdateRestrictionOnRegulatoryPolicy } from './actions/showUpdateRestrictionOnRegulatoryPolicy';

// Create lazily loadable RetentionPolicies chunk.
const lazyModule = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "RetentionPolicies" */ './lazyIndex'),
    { name: 'RetentionPolicies' }
);

export const lazyOnArchiveTagForFolderChanged: LazyImport<
    typeof lazyIndex.onArchiveTagForFolderChanged,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.onArchiveTagForFolderChanged);

export const lazyOnAssignPolicy: LazyImport<
    typeof lazyIndex.onAssignPolicy,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.onAssignPolicy);

export const lazyOnDeleteTagForFolderChanged: LazyImport<
    typeof lazyIndex.onDeleteTagForFolderChanged,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.onDeleteTagForFolderChanged);

export const lazyGetAssignPolicyPropertiesForMailContextMenu: LazyImport<
    typeof lazyIndex.getAssignPolicyPropertiesForMailContextMenu,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.getAssignPolicyPropertiesForMailContextMenu);

export const lazyShouldSkipRequestToServerDueToPolicy: LazyImport<
    typeof lazyIndex.shouldSkipRequestToServerDueToPolicy,
    LazyModule<typeof lazyIndex>
> = new LazyImport(lazyModule, m => m.shouldSkipRequestToServerDueToPolicy);

export const LazyRetentionPolicySubmenu: typeof lazyIndex.RetentionPolicySubmenu =
    createLazyComponent(lazyModule, m => m.RetentionPolicySubmenu);

registerLazyOrchestrator(
    showActionRestrictionDueToPolicy,
    lazyModule,
    m => m.showActionRestrictionDueToPolicyOrchestrator
);

registerLazyOrchestrator(
    showUpdateRestrictionOnRegulatoryPolicy,
    lazyModule,
    m => m.showUpdateRestrictionOnRegulatoryPolicyOrchestrator
);
